import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import Icon from "components/Icon";
import Button from 'components/Button';

import css from "./CuriousBlock.module.scss";

class CuriousBlock extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string.isRequied,
        text: PropTypes.string.isRequired,
        link: PropTypes.string,
        linkText: PropTypes.string,
        icon: PropTypes.string,
    };

    state = {
        shown: false
    };

    render() {
        const { className, text, link, linkText, icon } = this.props;
        const { shown } = this.state;
        const iconToShow = icon ? icon : 'binoculars';

        return (
            <div
                className={cn(css.block, className, {
                    [css.shown]: shown
                })}
            >
                <button onClick={() => this.setState({ shown: !shown })}>
                    <div>
                        <Icon
                            className={cn(css.icon, {
                                [css.large]: icon && !shown
                            })}
                            icon={shown ? "close" : iconToShow}
                        />
                    </div>
                </button>
                {shown && (
                    <div className={css.tooltip}>
                        <Icon className={cn(css.tooltipIcon, {
                            [css.large]: icon
                        })} icon={iconToShow} />
                        <p>{text}</p>
                        {link && linkText && (
                            <p className={css.link}>
                                <Button secondary blue href={link}>{linkText}</Button>
                            </p>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default CuriousBlock;



// WEBPACK FOOTER //
// ./src/components/CuriousBlock/CuriousBlock.jsx